<template>
    <ContentLayout>
        <div class="space-y-8">
            <header>
                <Breadcrumb :items="breadcrumbs" />
                <Heading :level="1" title="Layouts" subtitle="Preview of layout components." />
            </header>

            <Card>
                <CardContent class="space-y-4 rounded">
                    <section class="space-y-6 pt-6">
                        <Heading :level="2" title="Visuals" />

                        <section class="space-y-4">
                            <div>
                                <Heading
                                    :level="3"
                                    title="Sidebar Layout"
                                    subtitle="The SidebarLayout component provides a two-column, responsive layout with a fixed-width sidebar on larger screens and full-width stacking on smaller screens."
                                />
                            </div>

                            <div class="border">
                                <SidebarLayout>
                                    <template #heading>
                                        <div
                                            class="mb-4 h-8 w-24 border-2 border-dotted border-gray-300 bg-gray-50"
                                        ></div>
                                    </template>
                                    <template #sidebar>
                                        <div
                                            class="mb-6 h-48 border-2 border-dotted border-gray-300 bg-gray-50 lg:mb-0 lg:h-96"
                                        ></div>
                                    </template>
                                    <template #main>
                                        <div class="h-96 border-2 border-dotted border-gray-300 bg-gray-50"></div>
                                    </template>
                                </SidebarLayout>
                            </div>
                        </section>

                        <section class="space-y-4">
                            <div>
                                <Heading
                                    :level="3"
                                    title="Content Layout"
                                    subtitle="The ContentLayout component provides a simple, single-column layout for pages."
                                />
                            </div>

                            <div class="border">
                                <ContentLayout>
                                    <template #heading>
                                        <div
                                            class="mb-4 h-8 w-24 border-2 border-dotted border-gray-300 bg-gray-50"
                                        ></div>
                                    </template>
                                    <div class="h-96 border-2 border-dotted border-gray-300 bg-gray-50"></div>
                                </ContentLayout>
                            </div>
                        </section>
                    </section>

                    <section class="space-y-6 pt-6">
                        <Heading :level="2" title="Code" />

                        <section class="space-y-4">
                            <div>
                                <Heading
                                    :level="3"
                                    title="SidebarLayout Component"
                                    title-class="font-mono text-sm uppercase text-slate-700"
                                />
                            </div>
                            <pre
                                class="h-96 overflow-x-auto rounded bg-gray-900 p-4 text-green-200"
                            ><code>{{ SidebarLayoutCode }}</code></pre>
                        </section>

                        <section class="space-y-4">
                            <div>
                                <Heading
                                    :level="3"
                                    title="ContentLayout Component"
                                    title-class="font-mono text-sm uppercase text-slate-700"
                                />
                            </div>
                            <pre
                                class="h-96 overflow-x-auto rounded bg-gray-900 p-4 text-green-200"
                            ><code>{{ ContentLayoutCode }}</code></pre>
                        </section>
                    </section>
                </CardContent>
            </Card>
        </div>
    </ContentLayout>
</template>

<script setup>
import { useRouter } from 'vue-router'
import Breadcrumb from '@/partials/navigation/Breadcrumb.vue'
import { ContentLayout, SidebarLayout } from '@/components/ui/layouts'
import { Heading } from '@/components/ui/typography'
import { Card, CardContent } from '@/components/ui/card'
import ContentLayoutCode from '@/components/ui/layouts/ContentLayout.vue?raw'
import SidebarLayoutCode from '@/components/ui/layouts/SidebarLayout.vue?raw'

const router = useRouter()

const breadcrumbs = [{ label: 'Playground', onClick: () => router.push({ name: 'playground' }) }, { label: 'Layouts' }]
</script>
